import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { FinePrint, PrivacyWrapper } from '../../util'
import { Button } from '../../../util'
import * as bootupSelectors from 'services/bootup/selectors'
import * as consentActions from 'services/consents/actions'
import { SubmissionError } from 'redux-form'

const mapStateToProps = (state) => ({
  accountPortalRoot: bootupSelectors.selectAccountPortalRoot(state),
})

const mapDispatchToActions = {
  ...consentActions,
}

class TermsOfService extends Component {

  static propTypes = {
    accountPortalRoot: PropTypes.string,
    tosContent: PropTypes.array,
    updateConsents: PropTypes.func,
    consentMatrixVersion: PropTypes.string,
    gdprIsoCode: PropTypes.string,
  }

  handleUpdateConsents = () => {
    const { consentMatrixVersion, gdprIsoCode, tosContent, updateConsents } = this.props
    const consents = {
      [tosContent[0].id]: true,
    }
    return updateConsents(consentMatrixVersion, gdprIsoCode, consents)
      .then(() => {
        window.location.href = window.location.href
      })
      .catch((err) => {
        throw new SubmissionError({ _error: err.response.data.error })
      })
  }

  render () {
    const { accountPortalRoot, tosContent } = this.props
    const { contentUrl } = tosContent[0]
    const termsLink = `${accountPortalRoot}/terms-and-conditions`
    const privacyLink = `${accountPortalRoot}/privacy`

    return (
      <PrivacyWrapper>
        <iframe width="100%" src={contentUrl} style={ { minHeight: '500px', marginBottom: 20 } } />
        <FinePrint>
          <FormattedHTMLMessage
            id='privacy_center.terms.by_agreeing'
            defaultMessage={'By accepting, you agree to our <a href="{ termsLink }" target="_blank">Terms</a> and <a href="{ privacyLink }" target="_blank">Privacy Policy</a>.'}
            values={ {
              termsLink,
              privacyLink,
            } }
          />
        </FinePrint>
        <Button size='xlarge' type='mmr' onClick={this.handleUpdateConsents} style={ { width: '100%' } }>
          <FormattedMessage
            id='privacy_center.terms.cta'
            defaultMessage='Accept'
          />
        </Button>
      </PrivacyWrapper>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(TermsOfService)
